import { createStorefrontApiClient } from '@shopify/storefront-api-client';

export const storefront = createStorefrontApiClient({
  storeDomain: window?.Shopify?.shop || import.meta.env.VITE_SHOPIFY_STORE_DOMAIN,
  apiVersion: '2025-07',
  publicAccessToken: window?.storefrontAccessToken?.personalisation || import.meta.env.VITE_SHOPIFY_STOREFRONT_API_TOKEN
});
